<h3 class="section-title">Rooms & Parking</h3>
<div class="grid" [formGroup]="lotForm">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>Bedrooms</mat-label>
        <input matInput type="number" formControlName="NoBedrooms" min="0" step="1">
        @if (hasError('NoBedrooms')) {
            <mat-error>{{ getErrorMessage('NoBedrooms', 'Bedrooms') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>Bathrooms</mat-label>
        <input matInput type="number" formControlName="NoBathrooms" min="0" step="1">
        @if (hasError('NoBathrooms')) {
            <mat-error>{{ getErrorMessage('NoBathrooms', 'Bathrooms') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>Living Rooms</mat-label>
        <input matInput type="number" formControlName="NoLivingRooms" min="0" step="1">
        @if (hasError('NoLivingRooms')) {
            <mat-error>{{ getErrorMessage('NoLivingRooms', 'Living Rooms') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>Garages</mat-label>
        <mat-select formControlName="NoGarages">
            @for (garageType of garageTypes; track garageType) {
                <mat-option [value]="garageType.id">
                    {{ garageType.label }}
                </mat-option>
            }
        </mat-select>
        @if (hasError('NoGarages')) {
            <mat-error>{{ getErrorMessage('NoGarages', 'Garages') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>Carparks</mat-label>
        <input matInput type="number" formControlName="NoCarparks" min="0" step="1">
        @if (hasError('NoCarparks')) {
            <mat-error>{{ getErrorMessage('NoCarparks', 'Carparks') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>Study</mat-label>
        <input matInput type="number" formControlName="NoStudy" min="0" step="1">
        @if (hasError('NoStudy')) {
            <mat-error>{{ getErrorMessage('NoStudy', 'Study') }}</mat-error>
        }
    </mat-form-field>
</div>
